import { ConfirmModal } from '../../components/ConfirmModal';
import './OrganizationPause.css';

interface ResumeOrganizationModalProps {
  isOpen: boolean;
  organizationName: string;
  loading: boolean;
  error: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

/** Confirms resuming (unpausing) a paused organization. */
export const ResumeOrganizationModal = ({
  isOpen,
  organizationName,
  loading,
  error,
  onConfirm,
  onClose,
}: ResumeOrganizationModalProps) => (
  <ConfirmModal
    isOpen={isOpen}
    title="Resume Organization"
    message={`Resume "${organizationName}"? Its users will immediately regain access to RosterPilot.`}
    confirmText={loading ? 'Resuming...' : 'Resume'}
    busy={loading}
    onConfirm={onConfirm}
    onClose={onClose}
  >
    {error && (
      <div className="org-pause-form__error" role="alert" data-testid="org-unpause-error">
        {error}
      </div>
    )}
  </ConfirmModal>
);
